import React from "react";
import { Paper, Typography, Grid, makeStyles, Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { LocationSelectButton, LocationStat } from "../Common";
import moment from "moment";

const useClasses = makeStyles(theme => ({
  paper: {
    [theme.breakpoints.up("sm")]: {
      height: "100%"
    }
  },
  paperGrid: {
    [theme.breakpoints.up("sm")]: {
      minHeight: "100%"
    }
  },
  statsContainer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: `linear-gradient(to bottom, ${theme.palette.divider}, ${theme.palette.divider}) 50% repeat-y`,
    backgroundSize: "1px 100%"
  },
  legalText: {
    color: theme.palette.grey[500],
    fontSize: "12px"
  }
}));

const LocationCardCompact = ({
  location,
  selectedLocation = { id: 0 },
  handleSelect,
  order,
  showSelectedAlert = false
}) => {
  const { t } = useTranslation();
  const classes = useClasses();

  return (
    <Paper elevation={0} className={classes.paper}>
      {showSelectedAlert && (
        <Alert severity="success">
          <strong>
            {t("components.location_card_compact.selected.title")}
          </strong>
        </Alert>
      )}
      <Grid
        container
        justify="space-between"
        direction="column"
        className={classes.paperGrid}
      >
        <Grid item>
          <Box p={2} textAlign="left">
            <Grid container spacing={2}>
              <Grid item xs>
                <Typography gutterBottom variant="h3" component="h2">
                  <strong>
                    {order && `${order}. `}
                    {location.name}
                  </strong>
                </Typography>
                <Typography>{location.address}</Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {location.slots_available && location.starting_at && (
          <Grid item>
            <Box className={classes.paperBottom}>
              <Box className={classes.statsContainer}>
                <Grid container alignItems="center">
                  <Grid item xs>
                    <LocationStat
                      label={t(
                        "components.location_card_compact.stats.test_slots.label"
                      )}
                      value={location.slots_available}
                    />
                  </Grid>
                  <Grid item xs>
                    <LocationStat
                      label={t(
                        "components.location_card_compact.stats.starting_at.label"
                      )}
                      value={`${moment(location.starting_at, "kk:mm:ss").format(
                        "h:mm a"
                      )}`}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
        )}
        <Grid item>
          <Box textAlign="right" p={1}>
            <LocationSelectButton
              location={location}
              selectedLocation={selectedLocation}
              handleClick={handleSelect}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export { LocationCardCompact };
